export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: "openid profile email",
    ui_locales: "es-AR",
  },
  cacheLocation: "localstorage" as const,
  useRefreshTokens: true,
  // Configuraciones adicionales para mejor UX y seguridad
  skipRedirectCallback: window.location.pathname === "/silent-renew",
  onRedirectCallback: (appState: any) => {
    window.history.replaceState(
      {},
      document.title,
      appState?.returnTo || window.location.pathname
    );
  },
  // Configuraciones de seguridad adicionales
  advancedOptions: {
    defaultScope: "openid profile email",
  },
  // Mejorar el manejo de errores
  errorPath: "/error",
};
